import { fetcher } from "../../../utils/Axios";
import { useQuery } from "@tanstack/react-query";
import { GET_OT_UTILIZATION_QUERY_KEY } from "../types/CommonTypes";
import { GET_OT_UTILIZATION_RESPONSE } from "../types/ResponseTypes";

async function getOtUtilizationCombined(tenantId: string, hospitalId: string, queryString: string): Promise<GET_OT_UTILIZATION_RESPONSE> {
  const baseUrl = "analytics/ot-utilization";
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
  
  const { data } = await fetcher({
    url,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data?.ots || [];
}

export default function useGetOtUtilizationQuery(tenantId: string, hospitalId: string, queryString: string = "") {
  return useQuery({
    queryKey: [GET_OT_UTILIZATION_QUERY_KEY, queryString, hospitalId],
    queryFn: () => getOtUtilizationCombined(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
} 